import "./hb-gold.module.css";
import { html } from "lit-html";
import { getUsername } from "../../../global";

export default (user) => html`
    <form id="hb-gold" class="hidden space-y-4 pb-0">
        <p
            class="mt-5 mb-3 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
            Pay Yearly and <strong>Get 20% OFF</strong>
        </p>
        <div
            class="w-full max-w-full p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
            <h5
                class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">
                Heart of Gold ℹ️
            </h5>
            <div class="flex items-baseline text-gray-900 dark:text-white">
                <span class="text-3xl font-semibold">$</span>
                <span class="text-5xl font-extrabold tracking-tight">30</span>
                <span
                    class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400"
                    >USD / month</span
                >
            </div>
            <ul role="list" class="space-y-5 my-7">
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Everything in <strong>Heart of Mithril</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        <strong>Gold Aura</strong> around your Beating Heart
                    </span>
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>$30 Store Credits</strong> per Month to
                        Purchase B-Stamps</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>FREE Shipping</strong> on All Purchases of
                        B-Stamps</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        FREE for your entire <strong>Family Crew</strong> (up to
                        10 members)
                    </span>
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>FREE Subscription</strong> on All B-Apps in
                        HeartBank® Ecosystem (Aquarius™ Browser)</span
                    >
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>20% Member Discount</strong> Off All Purchases
                        of B-Stamps</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited Check-In</strong> for Nearby
                        Discovery</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Advanced Family Safety</strong> with 333℠
                        Sidekick and Cloud History</span
                    >
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited Humanity Proofs</strong> using
                        Passkey Authentication</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited</strong> Cryptographic
                        <strong>Cloud Safes</strong> for Complete Privacy</span
                    >
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unique</strong> Cryptographic Cloud Safe per
                        B-Chest for <strong>Untraceable Privacy</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited</strong> Minting and Mining of
                        <strong>Beating</strong> B-Chests with Blockchain-Level
                        Security</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        Stablecoin Tipping via
                        <strong>HeartBank® Smart Contract</strong> for Complete
                        Anonymity
                    </span>
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited Cloud Storage</strong> of B-Chests
                        inside HeartBank® Cloud Vault and HeartBank®
                        Treasury</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>15% Gold Member Discount</strong> Off
                        HeartBank® Trove for Cloud Storage of Diamonds</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited Advanced</strong> Aquarius™ AI with
                        Chat, Voice, and Vision</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Unlimited Advanced</strong> AI Voice, AI Image,
                        and AI Video Generation of HeartBank® Jewels</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Priority</strong> Human Support via X Chat or
                        WhatsApp Chat</span
                    >
                </li>
            </ul>
            <a
                href2="#/phone"
                class="inline-flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 justify-center w-full text-center">
                Verify Your Government ID
            </a>
        </div>
        <p
            class="mt-[-5px] text-center text-xs font-medium text-gray-500 dark:text-gray-500">
            <a href="#/about/terms">Store credits have expiry terms ℹ️</a>
        </p>
        <p
            class="hidden mt-[-5px] text-center text-xs font-medium text-gray-500 dark:text-gray-500">
            <strong>HeartBank® Cloud Treasury</strong> requires a separate
            subscription plan ℹ️
        </p>
        <br />
        <div class="hidden">
            <label
                for="hb-gold-username"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Your USDC Ethereum Address ℹ️
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="off"
                    id="hb-gold-username"
                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Enter Ethereum Address" />
                <button
                    id="hb-gold-username-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </button>
            </section>
        </div>
        <div class="hidden">
            <label
                for="hb-gold-number"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Your Phone Number
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="off"
                    id="hb-gold-number"
                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.phoneNumber
                        ? user.phoneNumber
                        : "+180059THANK"}"
                    disabled />
                <button
                    id="hb-gold-number-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Remove
                </button>
            </section>
        </div>
    </form>
`;
